<template>
    <div class="homeownership">

        <div class="parallax-container">
            <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 ps-0 pe-0 container d-sm-block d-md-block d-lg-none d-xl-none" >
                <img src="../../../assets/home-ownership-background.jpg" alt="background for section">
            </div>
            <div class="parallax-title">
                <div class="hocontainer">
                    <h2 class="heading">Making Homeownership Possible for More Than 700,000 Families Since 1972.</h2>
                    <p class="message">
                        We're honored to finance the new construction homes of our PulteGroup Family of Companies.  We are 
                        committed to seeing the homeownership dreams of our customers become reality.  With more than 200 loan
                        options available, we work hard to understand and meet the needs of today's customer.
                    </p>
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pt-3">
                            <a class="btn btn-primary pmbtn" href="/login" role="button">Start Your Loan Process</a>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pt-3">
                            <a class="btn btn-primary pmbtn" href="https://servicing.pultemortgage.com/pultemortgage/#/login" role="button">Pay Your Mortgage</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pt-3">
                            
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pt-3">
                            <nav-link href="/mortgage-payment-help" target="_self"  >Need Help Paying?</nav-link>
                        </div>
                    </div>
                </div>
            </div>
            <parallax :speed-factor="0.5" breakpoint="(min-width: 769px)" class="d-none d-lg-block">
                <v-lazy-image 
                     :src="homeOwnershipBackground"
                     :src-placeholder="homeOwnershipBackgroundThumb" style="min-height:100%;height:100%;min-width:100%;"
                     alt="home ownership background"></v-lazy-image>
            </parallax>
            
        </div>

    </div>
</template>

<script>    
    import Parallax from '../../../components/Parallax.vue';
    import utilitiesMixin from '../../../mixins/Utilities';
    import { mapGetters } from 'vuex';
    import homeOwnershipBackground from '../../../assets/home-ownership-background.jpg';
    import homeOwnershipBackgroundThumb from '../../../assets/home-ownership-background-thumb.jpg';

    export default {
        name: 'home-ownership',
        analyticsCategory: 'Home Ownership',
        components: {
            Parallax
        },
        computed: {
            ...mapGetters(['siteLinks', 'isAuthenticated', 'paymentLink'])
        },
        mixins: [utilitiesMixin],
        data() {
            return {
                homeOwnershipBackground,
                homeOwnershipBackgroundThumb
            };
        },
        methods: {
            pay() {
              this.utilities.navigation.doNav(this.paymentLink, this.$route.name, this.$options.analyticsCategory);
            },
            doStartYourLoan() {
                window.scrollTo(0, 0);
                const startUrl = this.siteLinks.find( ({ key }) => key === 'startUrl' ).url;
                if (this.isAuthenticated) {
                    this.utilities.navigation.doNav(startUrl, this.$route.name, this.$options.analyticsCategory);
                } else {
                    this.utilities.navigation.doNav('login', this.$route.name, this.$options.analyticsCategory);
                }
            }
        }
    };
</script>

<style lang="scss">
    .homeownership {
        color: #ffffff;
        width:100%;
        margin-left:auto;
        margin-right:auto;

        .parallax-container{
            position:relative;
            .container{
                width:100%;
                height:100%;
                display:block;
                position:relative;
                overflow:hidden;
                .container img{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                }
           }
            
        }

        .parallax-title {
            position: absolute;
            top: 6vh;
            left: 0;
            right: 0;
            padding: 20px;
            
            color: white;
            text-align: center;
        }

        

        .hocontainer{
            margin: 0 auto;
            h2.heading
            {
                line-height:1.2em;
            }
            p.message{
                color: #ffffff;
                text-align: center;

            }
            a{
                color: #ffffff;
                &:hover{
                    color: #e7e7e7 !important;
                    text-decoration:none;
               }
            }
        }
    .parallax-container {
        height: 520px;
    }
            .hocontainer {
               width: 50%;
           }
        @media (max-width: 1025px) {
            .parallax-container {
                height: 520px;
            }
            .hocontainer {
               width: 75%;
           }
        }
        

        @media (max-width: 991px) {
            .parallax-container {
                height: 520px;
            }
            .hocontainer {
               width:75%;
           }
        }

    @media (max-width: 767px) {
        .parallax-container {
            height: 600px;
        }

        .hocontainer {
            width: 80%;
        }
    }
    @media (max-width: 475px) {
        .parallax-container {
            height: 660px;
        }

        .hocontainer {
            width: 90%;
        }
    }
        @media (max-width: 374px) {
            .parallax-container {
                height: 600px;
            }
            .hocontainer {
               width:90%;
           }
        }

    }

            
</style>